import * as colors from '@giphy/colors'
import { Button } from 'shared/components/buttons'
import FacebookIcon from 'shared/components/icons/facebook'
import styled from 'styled-components'

const Facebook = styled(Button)`
    background: ${colors.giphyDarkestGrey};
    border-radius: 3px;
    font-size: 15px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const ButtonText = styled.div`
    padding-left: 10px;
`

type Props = {
    className?: string
    onClick?: () => void
    label?: string
}

const FacebookButton = ({
    className,
    onClick = () => (location.href = `/login/facebook/${location.search}`),
    label = 'Login with Facebook',
}: Props) => (
    <Facebook className={className} onClick={onClick} type="button">
        <FacebookIcon />
        <ButtonText>{label}</ButtonText>
    </Facebook>
)

export default FacebookButton
